import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=b4e11b7e&scoped=true&"
import script from "./InputRadio.vue?vue&type=script&lang=ts&"
export * from "./InputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=b4e11b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e11b7e",
  null
  
)

export default component.exports